import React, { useEffect, useState } from "react";
import useAuth from "../hooks/useAuth";
import { formatterDate } from "../utils/FormatterDate";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";

const GruposHabilitados = ({ dataAll, index }) => {
  const { listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});

  useEffect(() => {
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        global_sumilla: obtenerLabelEtiqueta(
          "lbl_global_sumilla",
          listadoEtiquetas
        ),
        grupos_equivalente: obtenerLabelEtiqueta(
          "lbl_grupos_equivalente",
          listadoEtiquetas
        ),
        global_grupo: obtenerLabelEtiqueta(
          "lbl_global_grupo",
          listadoEtiquetas
        ),
        global_horario: obtenerLabelEtiqueta(
          "lbl_global_horario",
          listadoEtiquetas
        ),
        global_inicio: obtenerLabelEtiqueta(
          "lbl_global_inicio",
          listadoEtiquetas
        ),
        global_fin: obtenerLabelEtiqueta("lbl_global_fin", listadoEtiquetas),
        global_docente: obtenerLabelEtiqueta(
          "lbl_global_docente",
          listadoEtiquetas
        ),

        global_tutor: obtenerLabelEtiqueta(
          "lbl_global_tutor",
          listadoEtiquetas
        ),
        global_cred: obtenerLabelEtiqueta("lbl_global_cred", listadoEtiquetas),
        global_ciclo: obtenerLabelEtiqueta(
          "lbl_global_ciclo",
          listadoEtiquetas
        ),
        global_vez: obtenerLabelEtiqueta("lbl_global_vez", listadoEtiquetas),
      });
    }
  }, [listadoEtiquetas]);

  const {
    global_sumilla,
    grupos_equivalente,
    global_grupo,
    global_horario,
    global_inicio,
    global_fin,
    global_tutor,
    global_docente,
    global_cred,
    global_ciclo,
    global_vez,
  } = etiquetas;
  let hash = {};

  return (

    // (dataAll.equivalentes.length > 0) &&
    <div className="accordion-item">
      <h2
        className={`accordion-header  ${dataAll.basignado ? "accordion-selected" : ""
          }`}
        id={`heading${index}`}
      >
        <button
          className={`accordion-button ${index !== 0 ? "collapsed" : ""}`}
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#collapse${index}`}
          aria-expanded={`${index === 0 ? "true" : "false"}`}
          aria-controls={`collapse${index}`}
        >
          <p className="text-uppercase mb-0 fw-medium">
            {" "}
            {dataAll.nombreAsignatura}{" "}
            {dataAll.basignado && (
              <i className="bi bi-check-circle ms-1 text-blue"></i>
            )}
          </p>
        </button>
      </h2>

      <div
        id={`collapse${index}`}
        className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
        aria-labelledby={`heading${index}`}
        data-bs-parent="#accordionExampleSincro"
      >
        <div className="accordion-body px-0">
          <div className="asign-group-content pb-0">
            <p className="fw-medium mb-0">{global_sumilla}</p>
            <p>{dataAll.sumilla}</p>
         
          </div>

          {dataAll?.equivalentes.map((datas2, index2) => {
            return (
              <div key={index2}>
                {index2 === 0 ? (
                  <>
                    <div className={`asign-group-content pt-0`}>
                      <p className="fw-medium mb-0">{grupos_equivalente}</p>
                      <p className="">{datas2.dequivalente}</p>
                    </div>

                    <div className="table-responsive">
                      <table
                        className={`table table-striped align-middle  ${datas2.basignado ? "group-selected" : ""
                          }`}
                      >
                        <thead className="table-light">
                          <tr>
                            <th scope="col" style={{ textAlign: "center" }}>
                              {global_grupo}
                            </th>
                            <th scope="col">{global_horario}</th>
                            <th scope="col">{global_inicio}</th>
                            <th scope="col">{global_fin}</th>
                            <th scope="col">{global_docente}</th>
                             
                            <th scope="col">{global_ciclo}</th>
                            <th scope="col">{global_vez}</th>
                            <th scope="col">{global_cred}.</th>
                          </tr>
                        </thead>
                        <tbody>
                          {datas2?.ItemsEqui?.map((datas, index) => {
                            return (
                              <tr
                                key={index}
                                className={`${datas?.f?.basignado ? "groupSelect2" : ""
                                  }`}
                              >
                                <th scope="row" style={{ textAlign: "center" }}>
                                  {datas?.f?.sgrupo}{" "}
                                  {datas?.f?.basignado && (
                                    <i className="bi bi-check-circle ms-1 text-blue"></i>
                                  )}
                                </th>
                                <td>{datas?.f?.dhorario} </td>
                                <td>{formatterDate(datas?.f?.finicio)}</td>
                                <td>{formatterDate(datas?.f?.ffin)}</td>
                                <td>{datas?.f?.ddocente}</td>
                                {/* <td>{datas.dtutor}</td> */}
                                <td>{datas?.f?.cciclo}</td>
                                <td>{datas?.f?.nveces}</td>
                                <td>{datas?.f?.ncredito}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                     
                    </div>
                  </>
                ) : (
                  <>
                    <div className="px-3 py-2 border-top equiv-div">
                      <p className="mb-0 fw-medium">{grupos_equivalente}</p>
                      <p className="mb-0">{datas2.dequivalente}</p>
                    </div>

                    <div className="table-responsive">
                      <table
                        className={`table table-striped align-middle  ${datas2.basignado ? "group-selected" : ""
                          }`}
                      >
                        <thead className="table-light">
                          <tr>
                            <th scope="col" style={{ textAlign: "center" }}>
                              {global_grupo}
                            </th>
                            <th scope="col">{global_horario}</th>
                            <th scope="col">{global_inicio}</th>
                            <th scope="col">{global_fin}</th>
                            <th scope="col">{global_docente}</th>
                            {/* <th scope="col">{global_tutor}</th> */}
                            <th scope="col">{global_ciclo}</th>
                            <th scope="col">{global_vez}</th>
                            <th scope="col">{global_cred}.</th>
                          </tr>
                        </thead>
                        <tbody>
                          {datas2?.ItemsEqui?.map((datas, index) => {
                            return (
                              <tr
                                key={index}
                                className={`${datas?.f?.basignado ? "groupSelect2" : ""
                                  }`}
                              >
                                <th scope="row" style={{ textAlign: "center" }}>
                                  {datas?.f?.sgrupo}
                                  {datas?.f?.basignado && (
                                    <i className="bi bi-check-circle ms-1 text-blue"></i>
                                  )}
                                </th>
                                <td>{datas?.f?.dhorario} </td>
                                <td>{formatterDate(datas?.f?.finicio)}</td>
                                <td>{formatterDate(datas?.f?.ffin)}</td>
                                <td>{datas?.f?.ddocente}</td>
                               
                                <td>{datas?.f?.cciclo}</td>
                                <td>{datas?.f?.nveces}</td>
                                <td>{datas?.f?.ncredito}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                       
                    </div>
                  </>
                )}

                
              </div>
            );
          })}
        </div>
      </div>
    </div>
    
  );
};

export default GruposHabilitados;
